<div class="search">
    <button class="btn btn-info btn-purchasenewpack" (click)="newCoupon()">Create Coupon</button>
    <div class="search-input-icon">
        <div class="search-input"><i class="flaticon-search"></i></div>
        <input type='text' [placeholder]='"Search Coupons"' (keyup)='search()' [(ngModel)]="searchText" class="searchtext"/>
    </div>
</div>

<br>

<ngx-spinner
    bdColor="rgba(75, 55, 100, 0.5)"
    size="large"
    color="#fff"
    type="line-scale-pulse-out">
        <span class="chevron left"></span>
        <span class="chevron right"></span>
  </ngx-spinner>

<ngx-datatable 
    #packageTable 
    class='material striped datatable' 
    [rows]='displayCoupons' 
    [columnMode]='"force"'
    [headerHeight]='40' 
    [sorts]="[{prop: 'id', dir: 'desc'}]"
    [footerHeight]='20' 
    [scrollbarH]="true" 
    [scrollbarV]="true" 
    [rowHeight]="40"
    [reorderable]="true">

    <ngx-datatable-column prop="name" [sortable]="true" width="100">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                Coupon Name
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.couponTitle}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="endDate" [sortable]="true">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span (click)="sort()">
                End Date
            </span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            {{row.expirationInterval.endDate | date:'EEEE, MMMM d, y'}}
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="google" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Google Offer
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <a (click)="viewGoogleOffer(row)" download href="#">View</a>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="apple" [sortable]="false">
        <ng-template let-column="column" ngx-datatable-header-template let-sort="sortFn">
            <span>
                Apple Pkpass
            </span>
        </ng-template>
        <ng-template let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <a (click)="downloadPkPass(row)" download href="#">Download</a>
        </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column prop="actions" [sortable]="false" [minWidth]="130" [maxWidth]="130">
        <ng-template let-column="column" ngx-datatable-header-template class="actions-row">
            <span></span>
        </ng-template>
        <ng-template let-row="row" ngx-datatable-cell-template>
            <button class="btn btn-success btn-icon" (click)="editCoupon(row.id)"><i class="flaticon-edit-1"></i></button>
            <button class="btn btn-danger btn-icon" (click)="deleteCoupon(row.id)"><i class="flaticon-cancel"></i></button>
        </ng-template>
    </ngx-datatable-column>
</ngx-datatable>